import { Injectable, inject } from '@angular/core';

import { Fai, ProductFactory, QuoteModel } from '@bytel/bytel-sales';
import { Oauth2Service } from '@bytel/checkout';

import { MainCartService } from '@services/main-cart.service';
import { PtoService } from '@services/pto.service';

import { tunnelRoutes } from '@tunnel/routes';

import { format, parseISO } from 'date-fns';
import { Observable, of } from 'rxjs';

import { BasicObject } from '../../../interfaces/checkout.interface';
import { StepMock } from '../../../interfaces/mock.interface';
import { AppointmentsMock } from '../../../mocks-handler/mocks/appointments.mock';
import { PtoStep } from './pto.step';
import { Step } from './step';

@Injectable({
    providedIn: 'root',
})
export class AppointmentStep extends Step {
    public static readonly key: string = 'appointment';

    public routerLink: string = `/tunnel/${tunnelRoutes.appointment}`;
    public label: string = 'Prise de rendez-vous';
    public shortLabel: string = 'Rendez-vous';
    public next: Step;
    public icon: string = 'tri-clipboard-checklist'; // to une once tri version is updated: tri-addcalendar-rdv
    public hasReminder = true;
    public stepMocks: StepMock[] = [
        {
            url: '/referentiel/offres/',
            mocks: [
                {
                    key: 'premium_appointment',
                    label: 'Referentiel offre avec rdv premium',
                    default: true,
                    data: {
                        idOffre: '6364',
                        type: 'ABONNEMENT',
                        libelle: '4G box',
                        univers: 'MOBILE',
                        debutCommercialisation: '1900-01-01T00:00:00.000+0009',
                        finCommercialisation: '2100-12-31T00:00:00.000+0100',
                        finCommercialisationEffective: '2100-12-31T00:00:00.000+0100',
                        tarifHT: 33.325,
                        tauxTVA: 20.0,
                        tarifTTC: 39.99,
                        famillesOffre: [],
                        famillesVente: [{ idFamilleVente: '1034', libelleFamilleVente: 'RDV_INSTAL_PREMIUM' }],
                        bonusAccessibles: 'AUCUN',
                    },
                },
            ],
        },
        {
            url: '/creneaux-disponibles',
            mocks: [AppointmentsMock],
        },
    ];
    protected cartService = inject(MainCartService);
    protected oauth2Service = inject(Oauth2Service);
    protected ptoStep: PtoStep = inject(PtoStep);
    protected ptoService = inject(PtoService);

    constructor() {
        super();
        this._isLoaded.next(true);
    }

    public canAccess(): Observable<boolean> {
        return of(
            this.canDisplay() &&
                !!this.cartService.cartModel.cartId &&
                this.oauth2Service.isConnected &&
                this.ptoService._currentPto !== null,
        );
    }

    public canDisplay(): boolean {
        const quoteFai = this._getQuoteFai();
        if (quoteFai) {
            const principalSubscription: Fai = quoteFai.getPrincipalProduct<Fai>('Fai');
            return (
                ProductFactory.Is(principalSubscription, Fai, true) &&
                principalSubscription.technology === Fai.TECHNOLOGIES.FTTH
            );
        }

        return false;
    }

    public getReminderData(): string {
        const quoteFai = this._getQuoteFai();
        const storedAppointment: BasicObject = quoteFai?.forms?.appointment;
        if (storedAppointment) {
            const date: string = format(parseISO(storedAppointment.debutCreneau), 'dd/MM/yyyy');
            const start: string = format(parseISO(storedAppointment.debutCreneau), 'HH');
            const end: string = format(parseISO(storedAppointment.finCreneau), 'HH');
            return `Le ${date} entre ${start}h et ${end}h`;
        }
        return '';
    }

    private _getQuoteFai(): QuoteModel {
        return this.cartService.cartModel.quotes.find((quote) => quote.isAcquisitionFix());
    }
}
